import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {Button, Grid} from "semantic-ui-react";
import AutoCatalogSelectorStore from "./AutoCatalogSelectorStore";
import FieldWithFieldIdSelector from "../../Pages/Shared/FieldWithFieldIdSelector";

function AutoCatalogSelector(props: { store: AutoCatalogSelectorStore }) {
    const {store} = props;
    useEffect(() => {
        void store.loadMakes();
    }, [store]);

    return <>
        <Grid>
            <FieldWithFieldIdSelector nameWidth={8} fieldWidth={8} placeholder={'Выберите марку'} name={'Марка'}
                                      fields={store.makes}
                                      onChange={value => void store.setMake(value!)}
                                      value={store.make?.id} required search/>
            {store.canLoadModels &&
                <FieldWithFieldIdSelector nameWidth={8} fieldWidth={8} placeholder={'Выберите модель'} name={'Модель'}
                                          fields={store.models}
                                          onChange={value => void store.setModel(value!)}
                                          value={store.model?.id} required search/>}
            {store.canLoadGenerations &&
                <FieldWithFieldIdSelector nameWidth={8} fieldWidth={8} placeholder={'Выберите поколение'}
                                          name={'Поколение'}
                                          fields={store.generations}
                                          onChange={value => void store.setGeneration(value!)}
                                          value={store.generation?.id} required search/>}
            {store.canLoadModifications &&
                <FieldWithFieldIdSelector nameWidth={8} fieldWidth={8} placeholder={'Выберите модификацию'}
                                          name={'Модификация'}
                                          fields={store.modifications}
                                          onChange={value => void store.setModification(value!)}
                                          value={store.modification?.id} search/>}
            {store.canLoadComplectations &&
                <FieldWithFieldIdSelector nameWidth={8} fieldWidth={8} placeholder={'Выберите комплектацию'}
                                          name={'Комплектация'}
                                          fields={store.complectations}
                                          onChange={value => store.setComplectation(value!)}
                                          value={store.complectation?.id} search/>}
            {store.canLoadBodies &&
                <FieldWithFieldIdSelector nameWidth={8} fieldWidth={8} placeholder={'Выберите кузов'} name={'Кузов'}
                                          fields={store.bodies}
                                          onChange={value => store.setBody(value!)}
                                          value={store.body?.id} search/>}
        </Grid>
        <Grid>
            <Grid.Column textAlign={"right"}>
                {store.canApply && <Button basic color={'teal'} onClick={() => store.apply()}>Применить</Button>}
                {store.canCancel && <Button basic color={'red'} onClick={() => store.cancel()}>Отменить</Button>}
            </Grid.Column>
        </Grid>
    </>
}

export default observer(AutoCatalogSelector);